export enum AgentsRoutes {
  Agents = "/agents",
  AgentsMe = "/agents/me",
  AgentsMeEdit = "/agents/me/edit",
  AddAgent = "/agents/add",
  Teams = "/agents/teams",
  AddTeam = "/agents/teams/add",
}

export enum RoleChangePermissions {
  None = "none",
  CanChange = "can-change",
  CanChangeToViewerOnly = "can-change-to-viewer-only",
}
